export const FAVORITE_LABELS = {
  0: "Non-favorite",
  1: "Semi-favorite",
  2: "Favorite",
  3: "Reference",
};

export function getSupplierContextKey(prefix, itemUuid) {
  return `${prefix}-${itemUuid}`;
}

export function getSupplierDropdownEntry(supplierDropdownState, contextKey) {
  return supplierDropdownState?.[contextKey] || {};
}

export function isSupplierLoading(supplierDropdownState, contextKey) {
  return getSupplierDropdownEntry(supplierDropdownState, contextKey).loading === true;
}

export function hasMoreSuppliers(supplierDropdownState, contextKey) {
  return getSupplierDropdownEntry(supplierDropdownState, contextKey).hasMore === true;
}

export function getSupplierEntriesByContext(supplierProductData, dropdownEntry, selectedSupplier) {
  const supplierIds = [...(dropdownEntry.supplierIds || [])];

  if (selectedSupplier?.value != null && !supplierIds.includes(selectedSupplier.value)) {
    supplierIds.unshift(selectedSupplier.value);
  }

  return supplierIds.map((supplierId) => supplierProductData?.[supplierId]).filter((entry) => entry && entry.supplier);
}

export function mapGroupedSupplierItems(suppliers, options = {}) {
  const { includeCommission = false } = options;
  const groupedItems = [];
  let lastFavorite = null;

  suppliers
    .sort((a, b) => (b.supplier?.favorite ?? 0) - (a.supplier?.favorite ?? 0))
    .map(({ supplier }) => {
      const { id, meta, city, name, favorite } = supplier;
      const hotelClass = meta?.hotel_class ? `(${meta.hotel_class}) ${"*".repeat(meta.hotel_class)}` : null;
      const cityName = city || null;

      return {
        label: `${name}${hotelClass ? ` - ${hotelClass}` : ""}${cityName ? ` - ${cityName}` : ""}`,
        value: id,
        foc: meta?.foc,
        favorite,
        ...(includeCommission ? { commission: meta?.commission } : {}),
      };
    })
    .forEach((item) => {
      if (item.favorite !== lastFavorite) {
        lastFavorite = item.favorite;
        groupedItems.push({ header: FAVORITE_LABELS[item.favorite] ?? "-" });
      }
      groupedItems.push(item);
    });

  return groupedItems;
}

export function emitSupplierDropdownEvent(vm, eventName, { source, prefix, itemUuid, productType, keyword }) {
  vm.$emit(eventName, {
    contextKey: getSupplierContextKey(prefix, itemUuid),
    productType,
    source,
    ...(keyword !== undefined ? { keyword } : {}),
  });
}
